export default __webpack_public_path__ + "static/media/frame_33_delay-0.05s.1e8db285.gif";